import { css } from "@styled-system/css";
import { GanttPage } from "./pages/gantt";
import { MemoriesPage } from "./pages/memories";
import { NotFoundPage } from "./pages/not-found";
import { OverviewPage } from "./pages/overview";
import { TriagePage } from "./pages/triage";

// Minimal client-side router — no external router dependency
function getPage() {
  const path = window.location.pathname;
  if (path === "/" || path === "") return "overview";
  if (path === "/memories") return "memories";
  if (path === "/triage") return "triage";
  if (path === "/gantt") return "gantt";
  return "not-found";
}

export function App() {
  const page = getPage();

  return (
    <div
      className={css({
        minH: "screen",
        bg: "surface.sunken",
        color: "text.bold",
        fontFamily: "sans",
      })}
    >
      {page === "memories" && <MemoriesPage />}
      {page === "overview" && <OverviewPage />}
      {page === "triage" && <TriagePage />}
      {page === "gantt" && <GanttPage />}
      {page === "not-found" && <NotFoundPage />}
    </div>
  );
}
